// Labor opration options for estimate line item.   
export class LaborOperation {
    constructor(id: string, name: string, sortOrder: number, isActive: boolean) {
        this.id = id;
        this.name = name;
        this.sortOrder = sortOrder;
        this.isActive = isActive;
    }

    // Salesforce ID.
    public id: string;
    // Labor operation name.
    public name: string;
    // Sort order of labor operation.
    public sortOrder: number;
    // Denotes if labor operation is active.
    public isActive: boolean;
}